export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            投稿与联系
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            有猛料？欢迎随时向我们投稿
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="text-xl font-semibold font-heading text-foreground-900">
              爆料投稿渠道
            </h3>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-md mx-auto">
              如果您掌握网红娱乐圈一手黑料信息，欢迎通过以下方式联系我们。
              我们承诺严格保护投稿人隐私，所有爆料信息经核实后将第一时间发布。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-mail-line"></i>
                邮件投稿
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 hover:bg-secondary-200 text-secondary-700 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-message-2-line"></i>
                私信联系
              </a>
            </div>
            <p className="mt-5 text-xs text-foreground-400">
              投稿即表示您同意本站的内容使用规则 | 严禁捏造虚假信息
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}